import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_DETAILS_STEP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequestDetailsStepMutation($data: SvbrgIntakeRequestInput!) {
    sevenbridges {
      chatSession {
        request {
          requestNext(data: $data) {
            id
            accountingAreaId
            commodityGroupId
            costCenterId
            currency
            deliveryLocationId
            organizationId
          }
        }
      }
    }
  }
`);
